module.exports = __webpack_public_path__ + "static/media/ic_close_bg_red.05004a40.svg";